export const feesColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Name',
  },
  {
    name: 'feeAmountType',
    label: 'Write-off type',
  },
  {
    name: 'writeOffValue',
    label: 'Write-off value',
  },
];

export const feesDefaultSorter = {};

export const feesSchema = {};
